let handledExpiredCredential: string | null = null;
let googleIdTokenRefreshPromise: Promise<string | null> | null = null;

export function noteAuthenticatedCredential(credential?: string) {
  if (!credential) {
    return;
  }

  if (handledExpiredCredential && handledExpiredCredential !== credential) {
    handledExpiredCredential = null;
  }
}

export function shouldHandleSessionExpiry(expiredCredential?: string, currentCredential?: string) {
  if (!currentCredential) {
    return false;
  }

  const credentialToHandle = expiredCredential ?? currentCredential;
  if (credentialToHandle && handledExpiredCredential === credentialToHandle) {
    return false;
  }

  handledExpiredCredential = credentialToHandle ?? currentCredential;
  return true;
}

export async function getSharedFreshGoogleIdToken(fetchFreshGoogleIdToken: () => Promise<string | null>) {
  if (!googleIdTokenRefreshPromise) {
    googleIdTokenRefreshPromise = fetchFreshGoogleIdToken().finally(() => {
      googleIdTokenRefreshPromise = null;
    });
  }

  return googleIdTokenRefreshPromise;
}

export function resetSessionExpiryStateForTests() {
  handledExpiredCredential = null;
  googleIdTokenRefreshPromise = null;
}
